import Swal from 'sweetalert2';
import { useNavigate } from "react-router-dom";


const showPreSimulationSteps = (onProceed) => {

  Swal.fire({
    title: '<span style="color: #1e40af">⚡ Pre-Simulation Checklist</span>',
    html: `
      <div style="text-align: left; font-family: 'Segoe UI', system-ui, sans-serif">
        
        <!-- Header Description -->
        <p style="margin: 0 0 20px 0; color: #4b5563; font-size: 0.95rem; border-bottom: 1px solid #e5e7eb; padding-bottom: 12px">
          Please complete the following steps before initiating the simulation:
        </p>
        
        <!-- Step 1 -->
        <div style="display: flex; align-items: flex-start; gap: 14px; margin-bottom: 18px; padding: 10px 12px; background-color: #f0fdf4; border-radius: 10px; border-left: 3px solid #22c55e">
          <div style="background-color: #22c55e; color: white; width: 26px; height: 26px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-weight: bold; font-size: 0.85rem; flex-shrink: 0">1</div>
          <div>
            <strong style="color: #166534; font-size: 0.9rem">Verify Well Composition Data</strong>
            <p style="margin: 4px 0 0 0; font-size: 0.8rem; color: #4b5563">Confirm all 18 components are entered correctly for NK1, NK2 & NK3 wells</p>
          </div>
        </div>
        
        <!-- Step 2 -->
        <div style="display: flex; align-items: flex-start; gap: 14px; margin-bottom: 18px; padding: 10px 12px; background-color: #eff6ff; border-radius: 10px; border-left: 3px solid #3b82f6">
          <div style="background-color: #3b82f6; color: white; width: 26px; height: 26px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-weight: bold; font-size: 0.85rem; flex-shrink: 0">2</div>
          <div>
            <strong style="color: #1e3a8a; font-size: 0.9rem">Review Operational Parameters</strong>
            <p style="margin: 4px 0 0 0; font-size: 0.8rem; color: #4b5563">Check pressure (PSI), temperature (°C), and flow rates (bbl/d) for each well</p>
          </div>
        </div>
        
        <!-- Step 3 -->
        <div style="display: flex; align-items: flex-start; gap: 14px; margin-bottom: 18px; padding: 10px 12px; background-color: #fefce8; border-radius: 10px; border-left: 3px solid #eab308">
          <div style="background-color: #eab308; color: white; width: 26px; height: 26px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-weight: bold; font-size: 0.85rem; flex-shrink: 0">3</div>
          <div>
            <strong style="color: #854d0e; font-size: 0.9rem">Validate Alarm Limits</strong>
            <p style="margin: 4px 0 0 0; font-size: 0.8rem; color: #4b5563">Ensure all transmitter values are within HH/H/L/LL thresholds</p>
          </div>
        </div>
        
        <!-- Step 4 -->
        <div style="display: flex; align-items: flex-start; gap: 14px; margin-bottom: 18px; padding: 10px 12px; background-color: #fef2f2; border-radius: 10px; border-left: 3px solid #ef4444">
          <div style="background-color: #ef4444; color: white; width: 26px; height: 26px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-weight: bold; font-size: 0.85rem; flex-shrink: 0">4</div>
          <div>
            <strong style="color: #991b1b; font-size: 0.9rem">Check Safety Systems</strong>
            <p style="margin: 4px 0 0 0; font-size: 0.8rem; color: #4b5563">Verify ESD (Emergency Shutdown) and relief valves are operational</p>
          </div>
        </div>
        
        <!-- Step 5 -->
        <div style="display: flex; align-items: flex-start; gap: 14px; margin-bottom: 8px; padding: 10px 12px; background-color: #faf5ff; border-radius: 10px; border-left: 3px solid #a855f7">
          <div style="background-color: #a855f7; color: white; width: 26px; height: 26px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-weight: bold; font-size: 0.85rem; flex-shrink: 0">5</div>
          <div>
            <strong style="color: #6b21a5; font-size: 0.9rem">Current Configuration</strong>
            <p style="margin: 4px 0 0 0; font-size: 0.8rem; color: #4b5563">Select demo composition or use your own</p>
          </div>
        </div>
        
        <!-- Info Box -->
        <div style="margin-top: 20px; padding: 12px 14px; background-color: #f3f4f6; border-radius: 10px; border: 1px solid #e5e7eb">
          <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 6px">
            <span style="font-size: 1.1rem">📊</span>
            <strong style="color: #374151; font-size: 0.85rem">Simulation Scope</strong>
          </div>
          <p style="margin: 0; font-size: 0.75rem; color: #6b7280">
            This simulation will process well composition data for NK1, NK2 & NK3 wellheads and generate production forecasts.
          </p>
        </div>
        
        <!-- Confirmation Checkbox -->
        <div style="margin-top: 20px; padding: 10px 0; display: flex; align-items: center; gap: 10px">
          <input type="checkbox" id="confirmCheckbox" style="width: 18px; height: 18px; cursor: pointer">
          <label for="confirmCheckbox" style="color: #374151; font-size: 0.85rem; cursor: pointer">
            I have verified all steps above and confirm readiness for simulation
          </label>
        </div>
      </div>
    `,
    icon: 'info',
    showCancelButton: true,
    confirmButtonText: '🚀 Start Simulation',
    cancelButtonText: 'Cancel',
    confirmButtonColor: '#10b981',
    cancelButtonColor: '#6b7280',
    allowOutsideClick: false,
    allowEscapeKey: false,
    width: '720px',
    customClass: {
      popup: 'rounded-xl shadow-2xl',
      confirmButton: 'font-semibold px-6 py-2',
      cancelButton: 'font-semibold px-6 py-2'
    },
    didOpen: () => {
      // Disable confirm button initially
      const confirmBtn = Swal.getConfirmButton();
      confirmBtn.disabled = true;
      confirmBtn.style.opacity = '0.5';
      confirmBtn.style.cursor = 'not-allowed';
      
      // Enable when checkbox is checked
      const checkbox = document.getElementById('confirmCheckbox');
      checkbox.addEventListener('change', (e) => {
        confirmBtn.disabled = !e.target.checked;
        confirmBtn.style.opacity = e.target.checked ? '1' : '0.5';
        confirmBtn.style.cursor = e.target.checked ? 'pointer' : 'not-allowed';
      });
    },
    preConfirm: () => {
      const checkbox = document.getElementById('confirmCheckbox');
      if (!checkbox.checked) {
        Swal.showValidationMessage('Please confirm you have completed all steps');
        return false;
      }
      return true;
    }
  }).then((result) => {
    if (result.isConfirmed && onProceed) {
      onProceed();
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      Swal.fire({
        title: 'Simulation Cancelled',
        text: 'Returning to homepage.',
        icon: 'warning',
        timer: 2000,
        showConfirmButton: false
      }).then(() => {
        window.location.href = "/";
      });
    }
  });
};

export default showPreSimulationSteps;